import Component from '../abstracts/Component';

export default class SizeGuideLayerComponent extends Component {

  get SELECTORS() {
    return {
        main: '.jsSizeGuideLayer',
        trigger: '.jsSizeGuideTrigger',
    };
  }

  constructor() {
    super();
    
    this.cssVexClass= 'size-guide';
    this.customCloseClass = 'size-guide-close';
  }
  openVexLayer(vexModule,element,closeLabel){
      let vexInst = vexModule;
      vexInst.open({
          content: '',
          unsafeContent: element,
          showCloseButton: true,
          escapeButtonCloses: true,
          overlayClosesOnClick: true,
          appendLocation: 'body',
          contentClassName: this.cssVexClass,
          closeClassName: this.customCloseClass,
          closeAllOnPopState: true,
          afterOpen: function(){
              this.closeEl.dataset.closeLabel = closeLabel;
          }
      });
      
  }
  
  initSizeGuide(){
      let layer = document.querySelector(this.SELECTORS.main);
      let closeLabel = layer.dataset.vexCloseLabel;
      this.moduleLoader.loadModalAndExecute((module)=>{
          this.$on(this.$customEvents.SIZE_GUIDE.openLayer,()=>{
              console.log('SIZES!!!!');
              this.openVexLayer(module.default,layer,closeLabel);
          });
      });
  }
  
  closeHandler(vexInstance){
      let btn = document.querySelector(this.SELECTORS.closeVexBtn);
      
      btn.addEventListener('click',()=>{
          vexInstance.closeAll();
      })
  }
  
  triggerListener(){
      let allTriggers = document.querySelectorAll(this.SELECTORS.trigger);
      for (let trigger of allTriggers){
        trigger.addEventListener('click', ()=>{
            this.$emit(this.$customEvents.SIZE_GUIDE.openLayer);
        })
      }
  }
  render() {
    
    if(document.querySelector(this.SELECTORS.main)){
        this.initSizeGuide();
        this.triggerListener();
    }

    let myName = this.constructor.name;
    console.log(`[${myName}] Rendering..`);
  }
}
